import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPedestrian = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.25 .25a1.75 1.75 0 1 1 0 3.5a1.75 1.75 0 1 1 0-3.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.55 4.6c.25-.13.53-.2.82-.2h.5c.72 0 1.36.46 1.6 1.14l.72 2.08 1.72.86a.75.75 0 1 1-.67 1.34l-2-1a.75.75 0 0 1-.37-.42l-.22-.63-.66 2.62 1.92 1.75c.16.14.24.34.24.55V15.3a.75.75 0 0 1-1.5 0v-2.28L7.5 11.03l-.81 3.25-.42 1.08a.75.75 0 1 1-1.4-.54l.39-1 1.58-6.33-.84.45v1.56a.75.75 0 0 1-1.5 0V7.47c0-.28.15-.53.4-.66l2.65-2.2Z",
		fill: "currentColor"
	})]
});
export default SvgPedestrian;
